const cardBg = "#F6F2FC";
const labelColor = "#71529e";
const valueColor = "#1A1248";

const UserProfileCard = ({ user }) => (
  <div
    style={{
      background: cardBg,
      borderRadius: "10px",
      padding: "18px 18px 8px 18px",
      maxWidth: 500,
      margin: "auto",
      fontFamily: "inherit",
      color: labelColor,
      boxSizing: "border-box",
    }}
  >
    <div style={{ marginBottom: 6, fontSize: "16.5px" }}>
      <span style={{ fontWeight: 600, color: labelColor }}>Name: </span>
      <span style={{ color: valueColor }}>{user.userProfileDetails.name}</span>
    </div>
    <div style={{ marginBottom: 6, fontSize: "16.5px" }}>
      <span style={{ fontWeight: 600 }}>Email: </span>
      <span style={{ color: valueColor }}>{user.userProfileDetails.email}</span>
    </div>
    <div style={{ marginBottom: 6, fontSize: "16.5px" }}>
      <span style={{ fontWeight: 600 }}>Phone Number: </span>
      <span style={{ color: valueColor }}>
        {user.userProfileDetails.phone_number}
      </span>
    </div>
    <div style={{ marginBottom: 6, fontSize: "16.5px" }}>
      <span style={{ fontWeight: 600 }}>Residence: </span>
      <span style={{ color: valueColor }}>
        {user.userProfileDetails.residence}
      </span>
    </div>
    <div style={{ marginBottom: 6, fontSize: "16.5px" }}>
      <span style={{ fontWeight: 600 }}>Date of Birth: </span>
      <span style={{ color: valueColor }}>{user.userProfileDetails.dob}</span>
    </div>
    <div style={{ marginBottom: 6, fontSize: "16.5px" }}>
      <span style={{ fontWeight: 600 }}>Dyslexic: </span>
      <span style={{ color: valueColor }}>
        {user.userProfileDetails.is_dyslexic ? "Yes" : "No"}
      </span>
    </div>
    <div style={{ marginBottom: 6, fontSize: "16.5px" }}>
      <span style={{ fontWeight: 600 }}>Word Count: </span>
      <span style={{ color: valueColor }}>{user.wordCount}</span>
    </div>
  </div>
);

export default UserProfileCard;
